<template>
    <div v-if="this.isLoading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
        <div style="position:sticky;top:0;z-index:20;background:#ffffff;padding:0 24px;">
            <h2 v-if="isEdit" class="pb-2">{{ this.parentObject.pageTitle + ' – ' + this.parentObject.pageTitleValue}}</h2>
            <h2 v-else class="pb-2">{{ this.parentObject.pageTitle}}</h2>
        </div>
        <v-container>
            <v-form>
                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">
                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4">
                        <v-text-field outlined :label="$t('pmrewardrecord.simulationcode')" type="text"
                            ref="simulationcode" :rules="[rules.required]" @input="updateValue"
                            v-model="formData.simulationcode" dense 
                            class="v-input"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmrewardrecord.simulationdesc')" type="text"
                            ref="simulationdesc" :rules="[rules.required]"
                            v-model="formData.simulationdesc" @input="updateValue" dense 
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                        <v-autocomplete outlined :label="$t('pmassementrecord.pmassessmentdesc')"  ref="assessmentrecordid"
                            :rules="[rules.required]" v-model="formData.assessmentrecordid" dense :items="assessmentOptionList"
                            @input="updateValue" @change="changeAssessmentOption(formData.assessmentrecordid)" 
                            class="v-input"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentcode')" type="text" v-model="formData.assessmentcode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('appraisalrecord.periodfrom')" type="text" v-model="formData.startdate" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('appraisalrecord.perioduntil')" type="text" v-model="formData.enddate" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-autocomplete outlined :label="$t('columns.status')"  ref="statusid"
                            :rules="[rules.required]" v-model="formData.statusid" dense :items="statusOptionList"
                            @input="updateValue" class="v-input"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="5" sm="5" class="pb-n4 mt-n8">
                        <v-checkbox
                                outlined
                                ref="isfinalrecord"
                                v-model="formData.isfinalrecord"
                                :label="$t('pmrewardrecord.finalrecordtopost')"
                                @change="updateValue"
                                dense
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-autocomplete outlined :label="$t('pmrewardrecord.currencycode')" ref="currencyid"
                            :rules="[rules.required]" v-model="formData.currencyid" dense :items=" currencyOptionList"
                            @input="updateValue" @change="changeCurrencyOption(formData.currencyid)" 
                            class="v-input"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('latenessdeduction.currencycode')" type="text" v-model="formData.currencycode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <app-formbuttons 
                    v-on:SavePressed="saveHandler"
                    v-on:CancelPressed="cancelHandler" 
                />

                <div v-if="isEdit">
                    <v-row>
                        <v-col cols="6" sm="6" class="pt-4 pb-1">
                            <span class="review-stats-label">{{ $t('pmrewardrecord.rewardDetails') }}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-tabs v-model="activeTab">
                            <v-tab value="basicSalaryIncrement">{{ $t('pmrewardrecord.tabs.basicSalaryIncrement') }}</v-tab>
                            <v-tab value="bonus">{{ $t('pmrewardrecord.tabs.bonus') }}</v-tab>
                            <v-tab value="instruction">{{ $t('pmrewardrecord.tabs.instruction') }}</v-tab>
                            <v-tab value="bonusPostingInstruc">{{ $t('pmrewardrecord.tabs.bonusPostingInstruc') }}</v-tab>
                            <v-tab value="salaryPostingInstruc">{{ $t('pmrewardrecord.tabs.salaryPostingInstruc') }}</v-tab>
                        </v-tabs>
                    </v-row>
                    <v-row>
                        <v-tabs-items v-model="activeTab">
                            <v-tab-item key="basicSalaryIncrement"> 
                                <v-row>
                                    <v-col cols="12" sm="12" >
                                        <app-table 
                                            v-bind:parentObject="{
                                                tabHeader: tabHeader,
                                                detailItem: this.parentObject.pmRewardBasicSalaryDetailList,
                                                rewardrecordid: this.formData.id,
                                                pmassessmentrecordid: this.formData.assessmentrecordid,
                                            }"
                                            v-on:input="addItemHandler"
                                        />
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            
                            <v-tab-item key="bonus">
                                <v-row>
                                    <v-col cols="12" sm="12" >
                                        <app-table2 
                                            v-bind:parentObject="{
                                                tabHeader: tabHeader2,
                                                detailItem: this.parentObject.pmRewardBonusDetailList,
                                                rewardrecordid: this.formData.id,
                                                pmassessmentrecordid: this.formData.assessmentrecordid,
                                            }"
                                            v-on:input="addItemHandler"
                                        />
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item key="instruction">
                                <v-row>
                                    <v-col cols="12" sm="12">
                                            <app-subform
                                            v-bind:parentObject="{
                                            data: this.parentObject.pmRewardInstruction,
                                            rewardrecordid: this.formData.id,
                                            isEdit: this.parentObject.pmRewardInstructionIsEdit,
                                        }" v-on:error="forwardError"/>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item key="bonusPostingInstruc">
                                <v-row>
                                    <v-col cols="12" sm="12">
                                        <app-table3
                                            v-bind:parentObject="{
                                                tabHeader: tabHeader3,
                                                detailItem: this.parentObject.pmRewardBonusPostingInstrucDetailList,
                                                rewardrecordid: this.formData.id,
                                            }"
                                            v-on:input="addItemHandler"
                                        />
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item key="salaryPostingInstruc">
                                <v-row>
                                    <v-col cols="12" sm="12">
                                        <app-subform2
                                            v-bind:parentObject="{
                                            data: this.parentObject.pmRewardSalaryPostingInstruc,
                                            rewardrecordid: this.formData.id,
                                            isEdit: this.parentObject.pmRewardSalaryPostingInstrucIsEdit,
                                        }" v-on:error="forwardError"/>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-row>
                </div>
                </v-container>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import moment from 'moment';
import CRUDTable from "./CRUDTable";
import CRUDTable2 from "./CRUDTable2";
import CRUDTable3 from "./CRUDTable3";
import Form2 from "./Form2.vue";
import Form3 from "./Form3.vue";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-table": CRUDTable,
        "app-table2": CRUDTable2,
        "app-table3": CRUDTable3,
        "app-subform": Form2,
        "app-subform2": Form3,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                id: this.parentObject.data.id,
                simulationcode: this.parentObject.data.simulationcode,
                simulationdesc: this.parentObject.data.simulationdesc,
                assessmentrecordid: this.parentObject.data.assessmentrecordid,
                statusid: this.parentObject.data.statusid,
                isfinalrecord: this.parentObject.data.isfinalrecord,
                currencyid: this.parentObject.data.currencyid,

                stamp: this.parentObject.data.stamp,
                updatedby: this.parentObject.data.updatedby,
                //read only,4 column
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                assessmentcode: this.parentObject.data.assessmentcode,
                currencycode: this.parentObject.data.currencycode,
            },

            errMsg: '',
            isErr: false,
            isEdit: this.parentObject.isEdit,
            isAdvanceEdit: this.parentObject.isAdvanceEdit,
            isLoading: true,

            assessmentOptionList: [], // take necessary data only from Full
            assessmentOptionFull: [],// get full data from database
            statusOptionList: [], // take necessary data only from Full
            statusOptionFull: [],// get full data from database
            currencyOptionList: [], // take necessary data only from Full
            currencyOptionFull: [],// get full data from database

            //isEdit part, all the CRUD table and the tab header
            activeTab: 'basicSalaryIncrement', // Default active tab
            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.company'), value: 'companycode', width: 'auto', sortable: false},
                { text: this.$t('columns.branch'), value: 'branchcode', width: 'auto', sortable: false },
                { text: this.$t('columns.division'), value: 'divisioncode', width: 'auto', sortable: false },
                { text: this.$t('columns.department'), value: 'departmentcode', width: 'auto', sortable: false },
                { text: this.$t('columns.section'), value: 'sectioncode', width: 'auto', sortable: false},
                { text: this.$t('columns.unit'), value: 'unitcode', width: 'auto', sortable: false},
                { text: this.$t('columns.grade'), value: 'gradecode', width: 'auto', sortable: false},
                { text: this.$t('columns.job'), value: 'jobcode', width: 'auto', sortable: false},
                { text: this.$t('columns.employmenttype'), value: 'employmenttypecode', width: 'auto', sortable: false},
                { text: this.$t('columns.factorinpercentage'), value: 'factor', width: 'auto', sortable: false},
                { text: this.$t('pmassementrecord.finalrank'), value: 'finalrank', width: 'auto', sortable: false},
            ],
            tabHeader2: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.company'), value: 'companycode', width: 'auto', sortable: false},
                { text: this.$t('columns.branch'), value: 'branchcode', width: 'auto', sortable: false },
                { text: this.$t('columns.division'), value: 'divisioncode', width: 'auto', sortable: false },
                { text: this.$t('columns.department'), value: 'departmentcode', width: 'auto', sortable: false },
                { text: this.$t('columns.section'), value: 'sectioncode', width: 'auto', sortable: false},
                { text: this.$t('columns.unit'), value: 'unitcode', width: 'auto', sortable: false},
                { text: this.$t('columns.grade'), value: 'gradecode', width: 'auto', sortable: false},
                { text: this.$t('columns.job'), value: 'jobcode', width: 'auto', sortable: false},
                { text: this.$t('columns.employmenttype'), value: 'employmenttypecode', width: 'auto', sortable: false},
                { text: this.$t('pmrewardrecord.bonusfactorfreq'), value: 'basicfreqcode', width: 'auto', sortable: false},
                { text: this.$t('pmrewardrecord.bonusfactor'), value: 'factor', width: 'auto', sortable: false},
                { text: this.$t('pmassementrecord.finalrank'), value: 'finalrank', width: 'auto', sortable: false},
            ],

            tabHeader3: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.effectivedate'), value: 'effectivedate', width: 'auto', sortable: false},
                { text: this.$t('columns.percentage'), value: 'percentage', width: 'auto', sortable: false},
            ],
        }
    },

    methods: {
        saveHandler() {
            this.updateValue();
            this.$emit('save');
        },

        cancelHandler() {
            this.$router.push({ name: 'pmrewardrecordlist' });
        },

        addItemHandler($event) {
            this.formData.basicsalaryincrement = $event;
            this.updateValue();
        },

        forwardError($event) {
            this.isErr = true;
            this.errMsg = $event.errMsg;
            this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
        },

        updateValue() {
            this.$emit('input', {

                simulationcode: this.formData.simulationcode,
                simulationdesc: this.formData.simulationdesc,
                assessmentrecordid: this.formData.assessmentrecordid,
                statusid: this.formData.statusid,
                isfinalrecord: this.formData.isfinalrecord,
                currencyid: this.formData.currencyid,

                stamp: this.formData.stamp,
                updatedby: this.formData.updatedby,

                //read only,4 column
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                assessmentcode: this.formData.assessmentcode,
                currencycode: this.formData.currencycode,

                //CRUD part
                basicsalaryincrement: this.formData.basicsalaryincrement,
            });
        },

        async loadAssessmentListHandler() {

            try {
                const res = await this.$store.dispatch('get', { url: "/pmassementrecord/calculatedAll" });
                this.assessmentOptionFull = res.data.rec;
                this.assessmentOptionList = []; // Clear the list before pushing new items

                for (let i = 0; i < res.data.rec.length; i++) {
                        this.assessmentOptionList.push({
                            text: res.data.rec[i].pmassessmentrecorddesc,
                            value: res.data.rec[i].id,
                        });
                }

                if (this.formData.assessmentrecordid) {
                    // Manually trigger the change handler to update other column, when edit record
                    this.changeAssessmentOption(this.formData.assessmentrecordid);
                }
                
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        changeAssessmentOption(id) {
            let item = this.assessmentOptionFull.find((item) => item.id === id);
            this.formData.assessmentcode = item.pmassessmentrecordcode;
            this.formData.startdate = moment(item.startdate).format('YYYY-MM-DD');
            this.formData.enddate = moment(item.enddate).format('YYYY-MM-DD');
        },

        async loadStatusListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: "/pmrewardstatus/all" });
                this.statusOptionFull = res.data.rec;
                this.statusOptionList = []; // Clear the list before pushing new items

                for (let i = 0; i < res.data.rec.length; i++) {
                        this.statusOptionList.push({
                            text: res.data.rec[i].rewardstatus,
                            value: res.data.rec[i].id,
                        });
                }                
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async loadCurrencyListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: "/currency/all" });
                this.currencyOptionFull = res.data.rec;
                this.currencyOptionList = []; // Clear the list before pushing new items

                for (let i = 0; i < res.data.rec.length; i++) {
                        this.currencyOptionList.push({
                            text: res.data.rec[i].crcydesc,
                            value: res.data.rec[i].id,
                        });
                }

                if (this.formData.currencyid) {
                    // Manually trigger the change handler to update other column, when edit record
                    this.changeCurrencyOption(this.formData.currencyid);
                }
                
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        changeCurrencyOption(id) {
            let item = this.currencyOptionFull.find((item) => item.id === id);
            this.formData.currencycode = item.crcycode;
        },


    },
    async mounted() {
        try {
            await this.loadAssessmentListHandler();
            await this.loadStatusListHandler();
            await this.loadCurrencyListHandler();
        
            this.isLoading = false;
        } catch (error) {
            console.error("Error loading data:", error);
        }
    }

}
</script>

<style scoped>
.theme--light.v-tabs-items {
  
    width: 100%;
}
</style>